import type { ReactNode } from 'react';
import './Kbd.css';

/** DESIGN.md §9.1 `Kbd` — a single key-cap glyph. Compose several for a chord: `<Kbd>Ctrl</Kbd>+<Kbd>K</Kbd>`. */
export function Kbd({ children }: { children: ReactNode }) {
  return <kbd className="kbd text-meta tabular-nums">{children}</kbd>;
}
